export default __webpack_public_path__ + "static/media/Vector-5.78030455.svg";